<mat-form-field appearance="outline">
    <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
    <input matInput  [placeholder]="easControl.field.widget.placeholder"  type="password" [formControl]="easControl.control">
    <mat-error *ngIf="this.easControl.control.errors">{{errors}}</mat-error>
</mat-form-field>
<ul class="list-unstyled">
@for (check of $checks(); track check.text) {
    <li>
        @if (check.valid) {
            <span class="text-success">
                &check; {{check.text}}
            </span>
        } @else {
            <span class="text-warn">
                &cross; {{check.text}}
            </span>
        }
    </li>
}
</ul>
@if (!easControl.field.widget.showInlineLabel) {
    <mat-hint>{{ easControl.field.widget.placeholder }}</mat-hint>
}
<label>Confirm your password
<mat-form-field appearance="outline">
    @if (easControl.field.widget.showInlineLabel) {
        <mat-label i18n>Confirm your password</mat-label>
    }
    <input matInput type="password" [formControl]="confirm">
    <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
</mat-form-field>
</label>
